module.exports = "# version 300 es\n\nvoid main()\n{             \n    // gl_FragDepth = gl_FragCoord.z;\n}  "


//////////////////
// WEBPACK FOOTER
// ./src/shaders/depth-instanced-frag.glsl
// module id = 80
// module chunks = 0